import Decision from "../Components/Decision";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import RegisterForm from "./RegisterForm";
import EventBanner from "./EventBanner";



export default function Register() {
    return (
      <div>
        <Header/>
        <RegisterForm />
        <EventBanner/>
        <Decision/>
        <Footer />
      </div>
    );
  }